import z from 'zod';
export const invoiceStatusValue = z.enum([
    'draft',
    'open',
    'unpaid',
    'paid',
    'void',
    'uncollectible',
]);
export const createInvoiceStatus = (value) => invoiceStatusValue.parse(value);
export const isInvoiceStatus = (value) => invoiceStatusValue.safeParse(value).success;
//# sourceMappingURL=invoice-status.js.map